var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide" } }, [
    _c(
      "div",
      {
        staticClass: "modal fade",
        class: _vm.onfilter ? "show" : "show",
        style: _vm.onfilter ? "display: block; padding-left: 0px;" : "",
        attrs: { tabindex: "-1", role: "dialog" },
      },
      [
        _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
          _c("div", { staticClass: "modal-content shadow-3" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c(
                "div",
                {
                  staticClass:
                    "icon icon-shape rounded-3 bg-soft-primary text-primary text-lg me-4",
                },
                [_c("i", { staticClass: "bi bi-funnel" })]
              ),
              _vm._v(" "),
              _c("div", [
                _c("h5", { staticClass: "mb-1" }, [_vm._v("Filtro")]),
                _vm._v(" "),
                _c("small", { staticClass: "d-block text-xs text-muted" }, [
                  _vm._v(
                    "Aplica los filtros para obtener la información que necesites."
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ms-auto" }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("div", { staticClass: "vstack gap-3" }, [
                _c("div", [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-4 pl-0 pr-0 pr-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Operador"),
                        ]),
                        _vm._v(" "),
                        _c("v-select", {
                          staticClass: "form-control form-control-sm",
                          attrs: {
                            items: _vm.operators,
                            "item-value": "id",
                            "item-text": "name",
                            "hide-details": "",
                          },
                          model: {
                            value: _vm.filter.operator,
                            callback: function ($$v) {
                              _vm.$set(_vm.filter, "operator", $$v)
                            },
                            expression: "filter.operator",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-8 pl-0 pr-0" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Campos"),
                        ]),
                        _vm._v(" "),
                        _c("v-select", {
                          staticClass: "form-control form-control-sm",
                          attrs: {
                            items: _vm.fields,
                            "item-value": "id",
                            "item-text": "name",
                            multiple: "",
                            "hide-details": "",
                          },
                          model: {
                            value: _vm.filter.fields,
                            callback: function ($$v) {
                              _vm.$set(_vm.filter, "fields", $$v)
                            },
                            expression: "filter.fields",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                String(
                  _vm.exclude.find(function (e) {
                    return e == "date"
                  })
                ) == "undefined"
                  ? _c("div", [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-md-6 pl-0 pr-0 pr-2" },
                          [
                            _c("small", { staticClass: "input-title" }, [
                              _vm._v("Desde"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "v-menu",
                              {
                                attrs: {
                                  "close-on-content-click": false,
                                  transition: "scale-transition",
                                  "offset-y": "",
                                  "min-width": "auto",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function (ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            "v-text-field",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass:
                                                    "form-control form-control-sm",
                                                  attrs: {
                                                    value:
                                                      _vm.filter.start_date,
                                                    "hide-details": "",
                                                    dense: "",
                                                    readonly: "",
                                                    clearable: "",
                                                  },
                                                  on: {
                                                    "click:clear": function (
                                                      $event
                                                    ) {
                                                      _vm.filter.start_date = ""
                                                    },
                                                  },
                                                },
                                                "v-text-field",
                                                attrs,
                                                false
                                              ),
                                              on
                                            )
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3347901366
                                ),
                                model: {
                                  value: _vm.menu_start,
                                  callback: function ($$v) {
                                    _vm.menu_start = $$v
                                  },
                                  expression: "menu_start",
                                },
                              },
                              [
                                _vm._v(" "),
                                _c("v-date-picker", {
                                  attrs: { "no-title": "", scrollable: "" },
                                  on: {
                                    input: function ($event) {
                                      _vm.menu_start = false
                                    },
                                  },
                                  model: {
                                    value: _vm.filter.start_date,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.filter, "start_date", $$v)
                                    },
                                    expression: "filter.start_date",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-md-6 pl-0 pr-0" },
                          [
                            _c("small", { staticClass: "input-title" }, [
                              _vm._v("Hasta"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "v-menu",
                              {
                                attrs: {
                                  "close-on-content-click": false,
                                  transition: "scale-transition",
                                  "offset-y": "",
                                  "min-width": "auto",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function (ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            "v-text-field",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass:
                                                    "form-control form-control-sm",
                                                  attrs: {
                                                    value: _vm.filter.end_date,
                                                    "hide-details": "",
                                                    dense: "",
                                                    readonly: "",
                                                    clearable: "",
                                                  },
                                                  on: {
                                                    "click:clear": function (
                                                      $event
                                                    ) {
                                                      _vm.filter.end_date = ""
                                                    },
                                                  },
                                                },
                                                "v-text-field",
                                                attrs,
                                                false
                                              ),
                                              on
                                            )
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1491432502
                                ),
                                model: {
                                  value: _vm.menu_end,
                                  callback: function ($$v) {
                                    _vm.menu_end = $$v
                                  },
                                  expression: "menu_end",
                                },
                              },
                              [
                                _vm._v(" "),
                                _c("v-date-picker", {
                                  attrs: { "no-title": "", scrollable: "" },
                                  on: {
                                    input: function ($event) {
                                      _vm.menu_end = false
                                    },
                                  },
                                  model: {
                                    value: _vm.filter.end_date,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.filter, "end_date", $$v)
                                    },
                                    expression: "filter.end_date",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                String(
                  _vm.exclude.find(function (e) {
                    return e == "user_id"
                  })
                ) == "undefined"
                  ? _c(
                      "div",
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Cliente"),
                        ]),
                        _vm._v(" "),
                        _c("search-user", {
                          attrs: { clearable: "" },
                          on: {
                            set_value: function (e) {
                              return (_vm.filter.user_id = e)
                            },
                          },
                          model: {
                            value: _vm.filter.user,
                            callback: function ($$v) {
                              _vm.$set(_vm.filter, "user", $$v)
                            },
                            expression: "filter.user",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                String(
                  _vm.exclude.find(function (e) {
                    return e == "state_id"
                  })
                ) == "undefined"
                  ? _c(
                      "div",
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Estado"),
                        ]),
                        _vm._v(" "),
                        _c("v-autocomplete", {
                          staticClass: "form-control form-control-sm",
                          attrs: {
                            multiple: "",
                            items: _vm.states,
                            "item-value": "id",
                            "item-text": "name",
                            "hide-details": "",
                            clearable: "",
                          },
                          on: {
                            "click:clear": function ($event) {
                              _vm.filter.state_id = []
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "prepend-item",
                                fn: function () {
                                  return [
                                    _c(
                                      "v-list-item",
                                      {
                                        attrs: { ripple: "" },
                                        on: {
                                          mousedown: function ($event) {
                                            $event.preventDefault()
                                          },
                                          click: _vm.toggle,
                                        },
                                      },
                                      [
                                        _c(
                                          "v-list-item-action",
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  color:
                                                    _vm.filter.state_id.length >
                                                    0
                                                      ? "indigo darken-4"
                                                      : "",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(_vm.icon) +
                                                    "\n                                            "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c("v-list-item-title", [
                                              _vm._v(
                                                "\n                                            Select All\n                                            "
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("v-divider", { staticClass: "mt-2" }),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "selection",
                                fn: function (ref) {
                                  var item = ref.item
                                  var index = ref.index
                                  return [
                                    index === 0
                                      ? _c("div", { staticClass: "mr-2" }, [
                                          _c("span", [
                                            _vm._v(_vm._s(item.name)),
                                          ]),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    index === 1
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "grey--text text-caption",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        (+" +
                                                _vm._s(
                                                  _vm.filter.state_id.length - 1
                                                ) +
                                                " others)\n                                    "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2260100784
                          ),
                          model: {
                            value: _vm.filter.state_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.filter, "state_id", $$v)
                            },
                            expression: "filter.state_id",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                String(
                  _vm.exclude.find(function (e) {
                    return e == "payment_state_id"
                  })
                ) == "undefined"
                  ? _c(
                      "div",
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Estado de pago"),
                        ]),
                        _vm._v(" "),
                        _c("v-autocomplete", {
                          staticClass: "form-control form-control-sm",
                          attrs: {
                            multiple: "",
                            items: _vm.payment_states,
                            "item-value": "id",
                            "item-text": "name",
                            "hide-details": "",
                            clearable: "",
                          },
                          on: {
                            "click:clear": function ($event) {
                              _vm.filter.payment_state_id = []
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "prepend-item",
                                fn: function () {
                                  return [
                                    _c(
                                      "v-list-item",
                                      {
                                        attrs: { ripple: "" },
                                        on: {
                                          mousedown: function ($event) {
                                            $event.preventDefault()
                                          },
                                          click: _vm.toggle_payment,
                                        },
                                      },
                                      [
                                        _c(
                                          "v-list-item-action",
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  color:
                                                    _vm.filter.payment_state_id
                                                      .length > 0
                                                      ? "indigo darken-4"
                                                      : "",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(_vm.icon_payment) +
                                                    "\n                                            "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c("v-list-item-title", [
                                              _vm._v(
                                                "\n                                            Select All\n                                            "
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("v-divider", { staticClass: "mt-2" }),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "selection",
                                fn: function (ref) {
                                  var item = ref.item
                                  var index = ref.index
                                  return [
                                    index === 0
                                      ? _c("div", { staticClass: "mr-2" }, [
                                          _c("span", [
                                            _vm._v(_vm._s(item.name)),
                                          ]),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    index === 1
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "grey--text text-caption",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        (+" +
                                                _vm._s(
                                                  _vm.filter.payment_state_id
                                                    .length - 1
                                                ) +
                                                " others)\n                                    "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2266536880
                          ),
                          model: {
                            value: _vm.filter.payment_state_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.filter, "payment_state_id", $$v)
                            },
                            expression: "filter.payment_state_id",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-h btn-primary px-3",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("onfilter")
                    },
                  },
                },
                [_vm._v("Aplicar")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-h btn-dark px-3",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("onclose")
                    },
                  },
                },
                [_vm._v("Cancelar")]
              ),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }